import { render, staticRenderFns } from "./SettingsP2PNotifications.vue?vue&type=template&id=183dd40f&scoped=true&"
import script from "./SettingsP2PNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsP2PNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SettingsP2PNotifications.vue?vue&type=style&index=0&id=183dd40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183dd40f",
  null
  
)

export default component.exports